import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { KeyFieldsConfig } from 'src/redux/slices/umibuilder/consts'
import { setKeyFieldAssignment } from 'src/redux/slices/umibuilder/reducers'
import {
  makeSelectAvailableColumns,
  makeSelectKeyFieldAssignment,
  makeSelectKeyFieldErrorMessage
} from 'src/redux/slices/umibuilder/selectors'
import { SelectOnChangeEvent } from 'src/types/event-handlers'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import Tooltip from '@material-ui/core/Tooltip'

///// Types
type KeyFieldSelectProps = {
  keyField: keyof typeof KeyFieldsConfig
}

///// Component
const KeyFieldSelector: React.FC<KeyFieldSelectProps> = ({ keyField }) => {
  const dispatch = useDispatch()
  const columnSelector = useMemo(() => makeSelectAvailableColumns(keyField), [keyField])
  const assignmentSelector = useMemo(() => makeSelectKeyFieldAssignment(keyField), [keyField])
  const errorSelector = useMemo(() => makeSelectKeyFieldErrorMessage(keyField), [keyField])
  const error = useSelector(errorSelector)
  const columns = useSelector(columnSelector)
  const value = useSelector(assignmentSelector)

  const handleChange = useCallback(
    async (e: SelectOnChangeEvent) => {
      dispatch(setKeyFieldAssignment({ field: keyField, value: String(e.target.value) }))
    },
    [dispatch, keyField],
  )

  const config = useMemo(() => KeyFieldsConfig[keyField], [keyField])

  // TODO:  add error state
  return (
    <Tooltip title={config.hover} enterDelay={750}>
      <FormControl fullWidth error={error ? true : false}>
        <InputLabel id='keyfield-selector-label'>{config.label}</InputLabel>
        <Select
          labelId='keyfield-selector-label'
          id='keyfield-selector'
          value={value ?? ''}
          onChange={handleChange}
        >
          {columns.map((column, i) => (
            <MenuItem value={column} key={`keyfields-option-${column}`}>
              {column}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </Tooltip>
  )
}

export default KeyFieldSelector
